import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

import NoBallRunsPopupDetails from './NoBallRunsPopupDetails.vue'

export const NoBallRunsPopup = new PopupBuilder('Number of No ball Runs')
  .appendBody(NoBallRunsPopupDetails)
  .build()
